import React from "react";
import ButtonLoader from "../ButtonLoader/ButtonLoader.component";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CustomInputField from "../CustomHTMLElements/CustomInputField";
import { yupValidators } from "../../helpers/yupValidators";

const schema = yup.object().shape({
  email: yupValidators.email,
});
export default function ResetPasswordStepOne({ onSubmitStepOne, loading }) {
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmit = async (data) => {
    const { email } = data;
    const reqBody = {
      email,
    };
    onSubmitStepOne(reqBody);
  };
  return (
    <form className="form" onSubmit={handleSubmit(onSubmit)}>
      <CustomInputField
        type="email"
        maxLength="256"
        reference={register}
        name="email"
        placeholder="Email"
        label="Please enter your email"
        errors={errors.email}
      />
      <button
        type="submit"
        value="submit"
        className="btn btn-sm btn-primary btn-block mt-4"
        disabled={loading}
      >
        {loading ? <ButtonLoader /> : "Proceed"}
      </button>
    </form>
  );
}
